import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorPauseDataProviderFactory } from '../factory/IntegrityMonitorPauseDataProviderFactory';
import { IntegrityMonitorPauseDataProvider } from '../dataProvider/IntegrityMonitorPauseDataProvider';
import { IntegrityMonitorPauseSchema } from '../type';

export class IntegrityMonitorPauseRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorPauseDataProviderFactory;
  public dataProvider: IntegrityMonitorPauseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorPauseDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IntegrityMonitorPauseSchema> {
    return this.dataProvider.getDataForView();
  }
}
